import {authorApi as apiClient} from './index';

export default {
  async renderMarkdown(data) {
    return await apiClient.post('render-md/', data)
  },

}
